"use client";
import React from "react";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels"; // Datalabels eklentisini içe aktar

const FinancialHorizontalBarChart = ({ data, labels, title }) => {
  const chartData = {
    labels: ["Skor"], // Her bir veri için aynı etiket kullanılabilir
    datasets: [
      {
        label: labels[0],
        data: [data[0]],
        backgroundColor: "rgba(75, 192, 192, 1)", // Mavi
        borderRadius: 10,
      },
      {
        label: labels[1],
        data: [data[1]],
        backgroundColor: "rgba(0, 255, 0, 0.7)", // Yeşil
        borderColor: "rgba(75, 192, 192, 1)",
        borderRadius: 10,
      },
      {
        label: labels[2],
        data: [data[2]],
        backgroundColor: "rgba(255, 99, 132, 1)", // Kırmızı
        borderColor: "rgba(255, 99, 132, 1)",
        borderRadius: 10,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          color: "#fff", // Beyaz yazı rengi
          font: {
            size: 14,
            weight: "bold", // Kalın yazı
          },
        },
      },
      title: {
        display: false,
        text: title,
      },
      datalabels: {
        anchor: "center",
        align: "center",
        color: "#fff", // Beyaz yazı rengi
        formatter: (value) => `${value}`,
        font: {
          size: 14,
          weight: "bold", // Kalın yazı
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 100,
        ticks: {
          callback: (value) => `${value}`,
          color: "#fff", // Beyaz yazı rengi
          font: {
            size: 14,
            weight: "bold", // Kalın yazı
          },
        },
      },
      y: {
        ticks: {
          color: "#fff", // Beyaz yazı rengi
          font: {
            size: 14,
            weight: "bold", // Kalın yazı
          },
        },
      },
    },
    animation: {
      duration: 800,
    },
    barPercentage: 0.8, // Bar genişliğini ayarlayın
    categoryPercentage: 0.9, // Barlar arasında mesafe
  };

  return (
    <div
      className="chart-wrapper-horizontal"
      style={{
        width: "100%",
        height: "250px",
        backgroundColor: "black", // Arka plan rengi
        padding: "20px",
        borderRadius: "25px",
      }} // Kenar yuvarlama
    >
      <Bar data={chartData} options={options} plugins={[ChartDataLabels]} />
    </div>
  );
};

export default FinancialHorizontalBarChart;
